import React from 'react';
import './animated-svg.css';

interface AnimatedCheckmarkProps {
	color?: string;
}

const AnimatedCheckmark: React.FC<AnimatedCheckmarkProps> = ({ color }) => {
	const strokeColor = color || 'var(--color-support-primary)';
	return (
		<div className='animated-svg-container'>
			<svg
				version='1.1'
				xmlns='http://www.w3.org/2000/svg'
				viewBox='0 0 130.2 130.2'
			>
				<circle
					className='path circle'
					fill='none'
					stroke={strokeColor}
					strokeWidth='6'
					strokeMiterlimit='10'
					cx='65.1'
					cy='65.1'
					r='62.1'
				></circle>
				<polyline
					className='path check'
					fill='none'
					stroke={strokeColor}
					strokeWidth='6'
					strokeLinecap='round'
					strokeMiterlimit='10'
					points='100.2,40.2 51.5,88.8 29.8,67.5'
				></polyline>
			</svg>
		</div>
	);
};

export default AnimatedCheckmark;
